import './back-to-top.js';
import './toc-smooth-scroll.js';
import './navigation.js';
import './sticky.js';
import './ontario-a11y.js';
import './ontario-expand-collapse.js';
import './ontario-header.js';
import './ontario-search.js';
import './svgxuse.js';
import './table-expand-collapse.js';
import './stonkinvestor-api.js'
import htmx from 'dist/unpkg.com/htmx.org@2.0.4/dist/htmx.esm.js';
window.htmx = htmx;

